<template>
  <div>
    <transition name="bounce">
      <div v-if="isSubmitted" class="loading-modal">
        <isSigning></isSigning>
      </div>
    </transition>
    <div class="container" :style="isSubmitted ? 'display: none;' : ''">
      <navBar/>

      <transition :name="routerTransition">

        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
          <div
            class="content-area__heading"
            :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
            <h2 class="mb-1">Firma Documento con Firel (PJF)</h2>
          </div>

          <!-- BREADCRUMB -->
          <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

        </div>
      </transition>


      <div class="vx-row">
        <div class="vx-col w-full md:w-full lg:w-2/3">

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-collapse type="margin" accordion class="p-0" >

                <vs-collapse-item class="bg-white" icon-pack="feather" icon-arrow="icon-arrow-down">
                  <div slot="header">
                    <h5 class="primary"><b>Firmar con Certificado Firel (PJF) en formato .pfx</b></h5>
                  </div>
                  <div class="pb-4">
                    <h5 class="mb-5">1. Ingresa tu Certificado .pfx</h5>
                    <div class="excel-import">
                      <input type="file" ref="fileInputPfx" class="hidden" accept=".pfx" @change="handleClickPfx">
                      <div
                        @click="$refs.fileInputPfx.click()"
                        @drop="handleDropPfx"
                        @dragover="handleDragoverPfx"
                        @dragenter="handleDragoverPfx"
                        class="px-8 py-6 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                        <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                        <div v-if="!pfx">
                          <span>Arrastra o </span>
                          <span  class="font-medium text-primary" @click.stop="$refs.fileInputPfx.click()">selecciona tu .pfx</span>
                        </div>
                        <span class="block" v-else><b>{{pfx.name}}</b></span>
                      </div>
                    </div>
                  </div>
                </vs-collapse-item>
                <vs-collapse-item class="bg-white" open icon-pack="feather" icon-arrow="icon-arrow-down">
                  <div slot="header">
                    <h5 class="primary"><b>Firmar con Certificado Firel (PJF) en formato .cer y .key</b></h5>
                  </div>
                  <div class="pb-4">
                    <h5 class="mb-5">1. Ingresa tu Certificado .cer</h5>
                    <div class="excel-import">
                      <input type="file" ref="fileInputCer" class="hidden" accept=".cer" @change="handleClickCer">
                      <div
                        @click="$refs.fileInputCer.click()"
                        @drop="handleDropCer"
                        @dragover="handleDragoverCer"
                        @dragenter="handleDragoverCer"
                        class="px-8 py-6 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                        <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                        <div v-if="!cer">
                          <span>Arrastra o </span>
                          <span  class="font-medium text-primary" @click.stop="$refs.fileInputCer.click()">selecciona tu .cer</span>
                        </div>
                        <span class="block" v-else><b>{{cer.name}}</b></span>
                      </div>
                    </div>
                  </div>
                  <div class="pt-4">
                    <h5 class="mb-5">2. Ingresa tu Llave Privada .key</h5>
                    <div class="excel-import">
                      <input type="file" ref="fileInputKey" class="hidden" accept=".key" @change="handleClickKey">
                      <div

                        @click="$refs.fileInputKey.click()"
                        @drop="handleDropKey"
                        @dragover="handleDragoverKey"
                        @dragenter="handleDragoverKey"
                        class="px-8 py-6 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                        <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                        <div v-if="!key">
                          <span>Arrastra o </span>
                          <span class="font-medium text-primary" @click.stop="$refs.fileInputKey.click()">selecciona tu .key</span>
                        </div>
                        <span class="block" v-else><b>{{key.name}}</b></span>
                      </div>
                    </div>
                  </div>
                </vs-collapse-item>

              </vs-collapse>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-card>
                <div class="p-4">
                  <h5 class="mb-5">3. Ingresa tu contraseña del Certificado Firel (PJF)</h5>
                  <vs-input  icon-no-border icon-pack="feather" icon="icon-lock" :type="type" placeholder="Contraseña" v-model="password" class="w-full is-label-placeholder" />
                  <div class="form-control-position field-icon">
                    <a @click="showPassword">
                      <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
                    </a>
                  </div>

                  <vs-button class="mt-5" color="secondary" type="filled" @click="toggleTab(1)">Anterior</vs-button>

                  <vs-button :disabled="isSubmitted" ref="loadableButton" id="button-with-loading" class="float-right mt-5 vs-con-loading__container" @click="submitSign"  color="primary">
                    Firmar
                    <feather-icon icon="Edit3Icon" class="top-4 text-primary" svgClasses="w-4 h-4  text-white"></feather-icon>
                  </vs-button>

                </div>
              </vs-card>

            </div>
          </div>

        </div>

        <div class="vx-col w-full md:w-full lg:w-1/3">

          <vs-card>
            <div class="p-4">
              <h4 class="mb-3">Firma del documento</h4>
              <div>
                <p class="mb-1">Es importante que revises el documento antes de firmar.</p>
                <p class="mb-0">Este proceso modifica tu documento original agregando los elementos necesarios para este formato de firma.</p>
              </div>
            </div>
          </vs-card>

          <vs-card>
            <div class="p-4">
              <h4 class="mb-3">Información</h4>
              <div>
                <p class="mb-3">Los datos introducidos no serán almacenados, ni utilizados para ningún otro proceso.</p>
                <p class="mb-3">Al firmar el documento todos los datos serán enviados por un servidor seguro y los datos estarán resguardados.</p>
                <span class="pr-1">
<!--                <vs-alert class="d-inline-block" color="primary">
                  No cuento con Firel
                  <vx-tooltip class="d-inline-block" text="Más información" position="top">
                  <a target="_blank" href="https://ayuda.verificamex.com/article/19-obtener-la-e-firma-por-primera-vez">
                    <feather-icon icon="HelpCircleIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-primary"></feather-icon>
                  </a>
                </vx-tooltip>
                </vs-alert>-->
              </span>
                <span>
<!--                <vs-alert class="d-inline-block" color="success">
                  ¿Qué es e.firma?
                  <vx-tooltip class="d-inline-block" text="Más información" position="top">
                  <a target="_blank" href="https://ayuda.verificamex.com/article/16-que-es-la-e-firma">
                    <feather-icon icon="HelpCircleIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-success"></feather-icon>
                  </a>
                </vx-tooltip>
                </vs-alert>-->
              </span>
              </div>
            </div>
          </vs-card>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {quillEditor} from "vue-quill-editor";
import router from "../../../../router";
import isSigning from "./isSigning";

export default {
  name: "Sign",
  components: {
    navBar,
    isSigning
  },
  props: ['toggleTab'],
  data () {
    return {
      isSubmitted: false,
      icon: 'EyeIcon',
      type: 'password',
      cer: null,
      key: null,
      pfx: null,
      password: null,
      uuid: null
    }
  },
  methods: {
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    submitSign() {
      this.$store.dispatch("alert/clear", {}, {root:true});
      if (!this.uuid || !this.key || !this.cer || !this.password) {
        if (!this.pfx) {
          this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
          return;
        }
      }
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: "#button-with-loading",
        scale: 0.45
      });
      this.isSubmitted = true;
      this.$store.dispatch("document/sign", {
        uuid: this.uuid,
        key: this.key,
        cer: this.cer,
        password: this.password,
        pfx: this.pfx
      }).then(
        () => {
          this.toggleTab(3);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        },
        () => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        }
      )
    },
    handleDragoverPfx (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDropPfx (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Subir',
          text: 'Solo puedes subir un archivo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      this.uploadFilePfx(rawFile)
    },
    handleClickPfx (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFilePfx(rawFile)
    },
    uploadFilePfx (file) {
      this.$refs['fileInputCer'].value = null // fix can't select the same excel
      this.pfx = file;
    },

    handleDragoverCer (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDropCer (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Subir',
          text: 'Solo puedes subir un archivo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      this.uploadFileCer(rawFile)
    },
    handleClickCer (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFileCer(rawFile)
    },
    uploadFileCer (file) {
      this.$refs['fileInputCer'].value = null // fix can't select the same excel
      this.cer = file;
    },

    handleDragoverKey (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDropKey (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Subir',
          text: 'Solo puedes subir un archivo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      this.uploadFileKey(rawFile)
    },
    handleClickKey (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFileKey(rawFile)
    },
    uploadFileKey(file) {
      this.$refs['fileInputKey'].value = null // fix can't select the same excel
      this.key = file;
    }
  },
  created() {
    let uuid = this.$route.params.uuid;
    if (uuid) {
      this.uuid = uuid;
    } else {
      router.push("/");
    }
  }
}
</script>

<style scoped>

  .loading-modal {
    position: absolute;
    transform: translateY(-18px);
    width: 100vw;
    height: 100vh;
    background-color: #fcfcfc;
    z-index: 100000000;
  }
 .vs-collapse-item{
   -webkit-box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
   box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
   &:first-child {
     margin-top: 0;
   }
 }
</style>
